'use strict';

var util = require('./util');

var currentQuery = null,
    lastQuery = null,
    runningQuery = null,
    listTotal = -1,
    listCurrent = 0,
    delay = 30,
    $resultsContainer,
    $searchContainer;
/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    //product suggestion
    var $productSuggestion = $resultsContainer.find(".product-suggestions").find(".product-suggestion");
    listTotal = $productSuggestion.length;
    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = (listCurrent - 1) % listTotal;
            break;
        case 40:
            // keyDown
            listCurrent = (listCurrent + 1) % listTotal;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $productSuggestion.removeClass('selected js-enter-btn').eq(listCurrent).addClass('selected js-enter-btn');
    return true;
}

var searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function (container, defaultValue) {
        $searchContainer = $(container);
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="q"]');
        var $searchFieldCross = $searchForm.find('.close-icon');
        
        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');
        
        if($('#wrapper').hasClass('pt_product-search-result') && $('#wrapper').hasClass('pt_product-search-result') && $(window).width() < 768){
        	$searchFieldCross.removeClass('hide-mobile');
        }
        $searchField.on("keyup",function (e) {
        	if (($searchField.val() == '' && e.keyCode == 8) || (e.ctrlKey && e.keyCode == 88)){
        		$searchFieldCross.addClass('hide-mobile');
        	} else {
        		$searchFieldCross.removeClass('hide-mobile');
        		if (!$($searchField).val()) {
        			$searchFieldCross.addClass('hide-mobile');
        		}
        	}
        });
        // on focus listener (clear default value)
        $searchField.focus(function () {
            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
        });
        $(document).on('click', function (e) {
        	if( !$(e.target).is('.user-panel') && !$(e.target).closest('.user-panel').length > 0 ) {
	        	if( $('body').find('.DelayHover').length > 0 ) {
	        		$('body').find('.DelayHover').removeClass('DelayHover');
	        	}
        	}
            if (!$searchContainer.is(e.target)) {
            	if(!$(e.target).is("input#q")) {
            		if($(e.target).closest("#search-suggestions").length < 1) {
            			var $input = $("form.simpleSearch").find("input#q");
                        if($input.val() != $input.attr('placeholder')) {
                	        $('.top-banner').removeClass('header-search-button');
                			$('.header-search').removeClass('focus');
                	    	$('.header-search').removeClass('search-button');
                	    	$('.simplesearch').removeClass('fixed-active');
                		} else {
                	    	$('.top-banner').addClass('header-search-button');
                			$('.header-search').addClass('focus');
                	    	$('.header-search').addClass('search-button');
                	    	$('.simplesearch').addClass('fixed-active');
                		}
                        if ($input.val() === '' || $input.val() === $input.attr('placeholder')) {
                            $('.top-banner').removeClass('header-search-button');
                			$('.header-search').removeClass('focus');
                	    	$('.header-search').removeClass('search-button');
                	    	$('.simplesearch').removeClass('fixed-active');
                        }
                        if($('.header-search').hasClass('focus') || $('.header-search').hasClass('active')){
                    	    $('.quick-order').addClass('quick-order-focus');
                        } else {
                    	    $('.quick-order').removeClass('quick-order-focus');
                        }
            		}
            	}
            }
        }.bind(this));
        // on key up listener
        $searchField.on("keyup click",function (e) {
            // get keyCode (window.event is for IE)
        	var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
        	var keyCode = e.keyCode;
        	if(is_explorer) {
        		keyCode = e.keyCode|| window.event.keyCode;
        	}
            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            // check for an ENTER or ESC
            if(keyCode === 9){
                return;
            }
            if (keyCode === 13 || keyCode === 27) {
                if ($('.js-enter-btn').length !== 0) {
                    event.preventDefault();
                    window.location.href = $('.js-enter-btn').find('a').attr('href');
                    return;
                }
                this.clearResults();
                return;
            }

            currentQuery = $searchField.val().trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));

        $( window ).resize(function() {
            this.setScrollBar();
        }.bind(this));
        
    },
    /**
     * @function
     * @description To set the scroll to the suggestion container
     */
    setScrollBar: function() {
        var	$windowHeight = $(window).height(),
            $headerBanner = $('.header-promo-banner').outerHeight(),
            $header = $('#header .top-menu-utility-wrapper').first().outerHeight(),
            $headerSearch = $('.header-search').first().outerHeight(),
            $headerSearchLabel = $('.search-result-label').first().height(),
            $headerPhrases = $('.phrase-suggestions').first().outerHeight(),
            $rightPanel = $(".right-panel").height(),
            $height = 0;

        if ($(window).width() > 767) {
            $height = $rightPanel - $headerSearchLabel - $headerSearch - $headerPhrases - 10;
        } else {
            $height = $windowHeight - $headerBanner - $header - $headerSearch - $headerPhrases - 20;
        }

        $height += "px";
    	if ($('#search-suggestions').find('.search-scrollbar-height .product-suggestion').length > 1) {
    		$('#search-suggestions').find('.search-scrollbar-height').slimScroll({destroy: true});
    		$('#search-suggestions').find('.search-scrollbar-height').slimScroll({
                height: $height,
                railVisible: true,
                color: "#000000",
                railColor: "#e9e9e9",
                distance: '9px',
                alwaysVisible: true
            });
    		return;
    	}
    	
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function () {
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if it's empty clear the results box and return
        if (runningQuery.length === 0) {
            this.clearResults();
            runningQuery = null;
            return;
        }

		var searchQuery = runningQuery;
		var regexp = '^[0-9]{1,4}-[0-9]{5}-[0-9]{3,4}$';
		
		// check if the sitewide sale is taking place and if the runningQuery is for a quick order number
		
		if ($("input[name='issitewide']") && $("input[name='issitewide']").attr("value") == "true" && searchQuery.match(regexp)) {
			searchQuery = searchQuery.split('-')[1];
		}
		
        // build the request url
        var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', searchQuery);

        // execute server call
        $.get(reqUrl, function (data) {
            var suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
                $resultsContainer.parent().removeClass('active');
            } else {
                // update the results div
                $resultsContainer.html(suggestionHTML).fadeIn(200);
                searchsuggest.setScrollBar();
                //setTimeout(function(){
                	//$('.phrase-suggestions').closest('.search-suggestion-wrapper').addClass('animate');
                	$('.phrase-suggestions').show("slide", { direction: "right" }, 300);
                	
                //},1000);
                $resultsContainer.parent().addClass('active');
            }

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
            this.hideLeftPanel();
        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$resultsContainer) { return; }
        $resultsContainer.fadeOut(200, function () {
            $resultsContainer.empty();
            $searchContainer.removeClass('active');
            if($('.header-search').hasClass('focus') || $('.header-search').hasClass('active')){
           	   $('.quick-order').addClass('quick-order-focus');
            } else {
           	   $('.quick-order').removeClass('quick-order-focus');
            }
        });
        
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function () {
        //hide left panel if there is only a matching suggested custom phrase
        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
    }
};

module.exports = searchsuggest;
